// src/Dashboard/pages/user/News/components/NewsKpis.jsx

import React from "react";
import {
  FaEye,
  FaEyeSlash,
  FaFilter,
  FaImage,
  FaNewspaper,
} from "react-icons/fa";

export default function NewsKpis({ stats, loading, isManager }) {
  const cards = [
    {
      key: "total",
      label: "Actualités",
      icon: FaNewspaper,
      tone: "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
    },
    {
      key: "active",
      label: "Visibles",
      icon: FaEye,
      tone: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    },
    {
      key: "withImage",
      label: "Avec image",
      icon: FaImage,
      tone: "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    },
    {
      key: "filtered",
      label: "Résultats",
      icon: FaFilter,
      tone: "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200",
    },
  ];

  if (isManager) {
    cards.splice(2, 0, {
      key: "inactive",
      label: "Masquées",
      icon: FaEyeSlash,
      tone: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    });
  }

  return (
    <div
      className={`grid gap-3 ${
        isManager ? "grid-cols-2 lg:grid-cols-5" : "grid-cols-2 lg:grid-cols-4"
      }`}
    >
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-[24px] border px-4 py-4 shadow-sm ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {loading ? "…" : stats?.[card.key] ?? 0}
              </span>
            </div>

            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}